<template>
  <div>
    <div class="card">
      <div class="bg-blue-light p-1">
        <TitleButton
            btnTitle="Register"
            :showBtn="false"
            :showAddNew="true"
            title="Employee List"
            @onClickAddNewButton="onClickAddNewButton"
        />
      </div>

      <div class="my-2 px-2">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-2 col-lg-2">
          <label class="col-form-label">Job Status</label>
            <v-select
                placeholder="Select Job Status"
                v-model="employmentJobStatus"
                :options="jobStatusList"
                label="name"
                :reduce="name => name.id"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-2 col-lg-2">
          <label class="col-form-label">Employee Category</label>
            <v-select
                placeholder="Select Employee Category"
                v-model="employmentEmployeeCategory"
                :options="employeeCategoryList"
                label="name"
                :reduce="name => name.id"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-2 col-lg-2">
          <label class="col-form-label">Designation</label>
            <v-select
                placeholder="Select Designation"
                v-model="employmentDesignation"
                :options="designationList"
                label="name"
                :reduce="name => name.id"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-2 col-lg-2">
          <label class="col-form-label">Branch</label>
            <v-select
                placeholder="Select Branch"
                v-model="employmentBranch"
                :options="branchList"
                label="name"
                :reduce="name => name.id"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-2 col-lg-2">
          <label class="col-form-label">Department</label>
            <v-select
                placeholder="Select Department"
                v-model="employmentDepartment"
                :options="departmentList"
                label="name"
                :reduce="name => name.id"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-2 col-lg-2">
              <label class="col-form-label">Blood Group</label>
              <select class="form-control" id="gender" v-model="bloodGroup">
                <option value=''>Select Blood group</option>
                <option v-for="(blood, key) in bloodGroups" :value="key">{{ blood }}</option>
              </select>
          </div>
          <div class="col-12 col-sm-6 col-md-2 col-lg-2">
            <label class="col-form-label">Search</label>
            <input type="text" v-model="searchTerm" class="form-control" placeholder="Search ">
          </div>
          <div class="col-2 d-flex align-items-end">
            <button
                style="min-width: 64px;"
                @click="getContactsList"
                class="btn btn-primary btn-block waves-effect waves-float waves-light"
            >Go
            </button>
          </div>
        </div>

        <div class="col-12">
          <div class="d-flex justify-content-end px-2">
            <button
                @click="exportList"
                class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
            >
              Export
            </button>
          </div>
        </div>
      </div>

      <div class="col-12 px-2 my-2">
        <ListTable :contacts="contacts"/>
      </div>

      <div class="px-2 position-absolute bottom-0">
        <Pagination
            :offset="offset"
            @onPageChange="onPageChange"
            ref="pagination"
        />
      </div>
    </div>
    <Loader v-if="loading"/>
  </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton.vue';
import ListTable from '@/components/molecule/company/hrm-payroll/employee-register/EmployeeListTable.vue';
import {useRoute, useRouter} from "vue-router";
import {computed, inject, onMounted, ref} from "vue";
import Loader from "@/components/atom/LoaderComponent.vue";
import Pagination from "@/components/atom/Pagination.vue";
import {useStore} from "vuex";
import handleRole from "@/services/modules/role";
import handleCompanyContact from "@/services/modules/companyContact";
import handleHospital from '@/services/modules/hospital'
import handleDepartments from "@/services/modules/procurement/organization-settings/department";
import handleBranches from "@/services/modules/procurement/organization-settings/branch";
import handleDesignation from "@/services/modules/procurement/organization-settings/designation";

const $route = useRoute();
const $router = useRouter();
const $store = useStore();

const showError = inject('showError');
const showSuccess = inject('showSuccess');
const {fetchEmployeeList} = handleCompanyContact();
const { fetchNoteMasterList } = handleHospital()
const {fetchCompanyDefaultRoles} = handleRole();
const { fetchBranchList } = handleBranches()
const { fetchDepartmentList } = handleDepartments()
const { fetchDesignationList } = handleDesignation()
const { fetchHome } = handleChartAccount()
import handleChartAccount from '@/services/modules/chartAccount'

const offset = ref(10);
const loading = ref(false);
const contacts = ref([])
const companyRules = ref([])
const employmentJobStatus = ref(null)
const employmentEmployeeCategory = ref(null)
const employmentBranch = ref(null)
const employmentDepartment = ref(null)
const bloodGroup = ref(null)
const employmentDesignation = ref(null)
const searchTerm = ref('');
let jobStatusList = ref([])
let employeeCategoryList = ref([])
let departmentList = ref([])
let branchList = ref([])
let designationList = ref([])
let bloodGroups = ref([])

// computed
const start = computed(() => $route.query.start);
const end = computed(() => $route.query.end);
const page = computed(() => $route.query.page);
const companyId = computed(() => $route.params.companyId);
const token = localStorage.getItem('token');

//methods
const setPaginationData = (data) => {
  $store.commit('setPaginationData', data)
};
const resetPagination = () => {
  $store.commit('resetPagination')
};

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, $route.query)
  routeQuery.page = page
  await $router.push({path: $route.path, query: routeQuery})
  await getContactsList()
}
const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onClickAddNewButton = () => {
  let params = {
    companyId: $route.params.companyId,
    moduleId: $route.params.moduleId,
    menuId: $route.params.menuId,
    pageId: $route.params.pageId,
  }
  $router.push({
    name: 'employee-register',
    params: params,
    query: $route.query
  })
}
const getQuery = () => {
  let query = '?company_id=' + companyId.value
  query += '&offset=' + offset.value
  query += '&is_supervisor=1'
  if (page) query += '&page=' + page.value
  if (employmentJobStatus.value) query += '&employment_job_status=' + employmentJobStatus.value
  if (employmentEmployeeCategory.value) query += '&employment_employee_category=' + employmentEmployeeCategory.value
  if (employmentBranch.value) query += '&employment_branch=' + employmentBranch.value
  if (employmentDepartment.value) query += '&employment_department=' + employmentDepartment.value
  if (employmentDesignation.value) query += '&employment_designation=' + employmentDesignation.value
  if (bloodGroup.value) query += '&blood_group=' + bloodGroup.value
  if (searchTerm) query += '&q=' + searchTerm.value
  return query
};

const getJobStatusList = async () => {
  let query = getQuery();
  query += '&is_all=true&status=active&note_type=job_status'

  jobStatusList.value = []

  await fetchNoteMasterList(query).then(res => {
    if (!res.status){
      jobStatusList.value = []
      return
    }
    jobStatusList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const getEmployeeCategoryList = async () => {
  let query = getQuery();
  query += '&is_all=true&status=active&note_type=employee_category'

  employeeCategoryList.value = []

  await fetchNoteMasterList(query).then(res => {
    if (!res.status){
      employeeCategoryList.value = []
      return
    }
    employeeCategoryList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const getBranchList = async () => {
  let query = getQuery();

  branchList.value = []

  await fetchBranchList(query).then(res => {
    if (!res.status){
      branchList.value = []
      return
    }
    branchList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const  getDesignationList = async () => {
  let query = getQuery();

  designationList.value = []

  await fetchDesignationList(query).then(res => {
    if (!res.status){
      designationList.value = []
      return
    }
    designationList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const getDepartmentList = async () => {
  let query = getQuery();

  departmentList.value = []

  await fetchDepartmentList(query).then(res => {
    if (!res.status){
      departmentList.value = []
      return
    }
    departmentList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

async function getContactsList() {
  try {
    const res = await fetchEmployeeList(getQuery());
    if (!res.status) {
      contacts.value = [];
      return resetPagination()
    }
    contacts.value = res.data.data;
    await setPagination(res.data)
  } catch (err) {
    if (err.response) {
      showError(err.response.message)
    }
  }
}

const exportList = () => {
  let objQuery = {
    company_id: $route.params.companyId,
    employment_job_status: employmentJobStatus.value ?? '',
    employment_employee_category: employmentEmployeeCategory.value ?? '',
    employment_branch: employmentBranch.value ?? '',
    employment_department: employmentDepartment.value ?? '',
    employment_designation: employmentDesignation.value ?? '',
    blood_group: bloodGroup.value ?? '',
    q: searchTerm.value ?? '',
    _token: token
  }
  let params = Object.entries(objQuery).map(([key, val]) => `${key}=${val}`).join('&');
  let url = `${process.env.VUE_APP_BASE_URL}/export/employees/?${params}`;
  let a = document.createElement('a');
  a.setAttribute('href', url);
  a.click();
}

onMounted(() => {
  loading.value = true;
  const companyQuery = `?company_id=${companyId.value}`
  const rolesRes = fetchCompanyDefaultRoles(companyQuery)
  Promise.all([
    rolesRes.then(res => {
      if (res.data) companyRules.value = res.data
    }),
    fetchHome().then(res => {
      if (res.data) {
        bloodGroups.value = res.data.blood_groups
      }
    }),
    getContactsList(),
    getJobStatusList(),
    getEmployeeCategoryList(),
    getBranchList(),
    getDepartmentList(),
    getDesignationList(),
  ]).then(() => {
    loading.value = false
  }).catch((err) => {
    loading.value = false
  })

})
</script>
